<template>
  <div>
    <div class="partTime-info">
      <p class="title">薪资待遇</p>
      <div style="color:red" v-if="detail.flexible_job">{{ detail.flexible_job.basic_salary }}元 / {{basic_salary_period[detail.flexible_job.basic_salary_period]}} · {{settlement_method[detail.flexible_job.settlement_method]}}</div>
      <div v-if="detail.flexible_job">提成：{{ detail.flexible_job.bonus_value || '无' }}{{ detail.flexible_job.bonus_type==2?'%':detail.flexible_job.bonus_type==3?'元/件':'' }}</div>
      <p v-if="detail.selling_point_tags">福利：{{ detail.selling_point_tags.join(' ') || '无福利'}}</p>
      <p class="title">工作内容</p>
      <p v-html="detail.requirements"></p>
      <p class="title">岗位要求</p>
      <p v-html="detail.description"></p>
      <p class="title">工作地址</p>
      <p>{{detail.province_name}}{{detail.city_name}}{{detail.dist_name}}</p>
      <p class="title">人员要求</p>
      <div>性别要求：{{ config.sex[detail.gender_id] || '不限' }}</div>
      <div>学历要求：{{ config.education[detail.education_id] }}</div>
      <div v-if="detail.flexible_job">身高要求：{{ detail.flexible_job.height_requirements == 0 ? '无要求' : `${detail.flexible_job.height_requirements}CM`}}</div>
      <p v-if="detail.flexible_job">健康证：{{detail.flexible_job.health_requirements == 1 ? "无要求":"需要" }}</p>
      <p class="title">联系方式</p>
      <p v-if="detail.flexible_job">{{ contactTypeData[detail.flexible_job.contact_type] }}{{detail.flexible_job.contact_value }}</p>
    </div>
    <div>
      <a-row>
        <a-col>
          <DividerBar text="招聘服务"></DividerBar>
          <div style="padding-left:30px">
            <p v-if="detail.job_attribute == 2">
              {{detail.recruit_service_type == 1 ? '面试快' : detail.recruit_service_type == 2 ? '入职快' : '过保快' }}服务 
              {{detail.service_fee_type == 1 ? detail.service_fee_value + '%年薪比例' : detail.service_fee_value + '元'}}
            </p>
            <p v-else>
              设置服务费
              {{detail.service_fee_type == 1 ? detail.service_fee_value + '%年薪比例' : detail.service_fee_value + '元'}}
            </p>
            <p v-if="detail.hunter_commission_type == 1">
              猎头佣金 {{detail.hunter_commission_value || 0}}%({{ detail.hunter_commission_max || 0 }}元)
            </p>
            <p v-else>
              猎头佣金 {{detail.hunter_commission_value || 0}}元
            </p>
            <p>平台抽佣 {{detail.platform_commission_rate || 0}}%({{ detail.platform_commission_value || 0 }}元)</p>
            <p>层级躺赚 按平台抽佣比例的 {{detail.layer_rate || 0}}%</p>
          </div>
        </a-col>
        <a-col>
          <DividerBar text="悬赏服务"></DividerBar>
          <div style="padding-left:30px">
            <p>悬赏金额：{{detail.company_reward_amount || 0}}元</p>
            <p>悬赏人数：{{detail.company_reward_offered_num || 0}}人</p>
            <p>截至时间：{{detail.company_reward_deadline}}</p>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
  import DividerBar from '@/components/dividerBar'
  import { mapState } from 'vuex'
  export default {
    components: { 
      DividerBar
    },
    props:{
      detail:{
        type:Object,
        default:()=>{
          return {}
        }
      }
    },
    computed: {
      ...mapState(['config']),
    },
    data() {
      return {
        basic_salary_period: ['', '小时', '天', '周', '月', '次', '其他'],
        settlement_method: ['', '日结', '周结', '月结', '完工结'],
        bonus_type: ['', '无提成', '业绩提成', '计件提成', '自定义'],
        contactTypeData: ['', '微信', '微信公众号', '电话联系', 'QQ', 'QQ群', '不要主动联系我']
      }
    },
  }
</script>

<style lang="scss" scoped="scoped">
  .partTime-info {
    margin-top: 30px;
    p {
      margin-bottom: 25px;
      line-height: 18px;
      &.title {
        font-weight: bold;
        font-size: 16px;
        &.inline {
          float: left;
          margin-right: 5px;
          margin-bottom: 15px;
        }
      }
    }
  }
</style>
